<template>
  <v-footer  class="justify-space-between text-center" fixed>
    <h6 class="mb-0 fw-normal w-100">{{copyrightText}}</h6>
  </v-footer>
</template>

<script>
import AppConfig from "@/config/AppConfig";

export default {
  data() {
    return {
      copyrightText: AppConfig.copyrightText
    };
  }
};
</script>
